<template>
  <div class="reset-password">
    <div class="container">
      <div class="brand-content">
        <img src="https://static.bienparabien.com/img/Logo_BPB_alt.png" alt="Logo BpB" width="200px">
        <h1>Recuperar contraseña</h1>
        <p>Ingresa tu correo para restablecer tu contraseña.</p>
      </div>
      <div class="login">
        <form @submit.prevent="recovery">
          <div class="form-group">
            <label for="reset-password-email"><small>Correo electrónico:</small></label>
            <input v-model="usuario" type="email" class="form-control" id="reset-password-email" aria-describedby="emailHelp">
          </div>

          <button type="submit" class="btn btn-bpb-primary col-sm-12">Recuperar</button>
        </form>
        <div class="form-group mt-4">
          <router-link class="btn btn-link col-sm-12" :to="{name: 'Home'}">Cancelar</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import api from '@/api/account'

  export default {
    data: () => ({
      usuario: null
      ,success: 0
    })
    ,methods: {
      recovery: async function() {

        let payload = {
          usuario: this.usuario
          ,url: encodeURI(process.env.VUE_APP_CLIENTES_FRONT_URL)
          ,vista: 'base'
        };

        try {
          await api.recuperar_password(payload);

          this.$swal('Exito!','Se a enviado a tu cuenta de correo un link para poder recuperar tu contraseña');
        }catch(e) {
          this.$log.info('err',e);
          this.$swal('Error','No se pudo iniciar el proceso de recuperación: '+e.message,'error');
        }
      }
    }
  }
</script>